// Container-Abgleich im Zustell-Dialog (Plan 2026-10-18 P3, Nutzerentscheidung 18.10.):
// nur Hinweis, keine Pflicht. Die Lagerleitung liest die Nummer am Container ab; eine
// Abweichung warnt gelb, sperrt aber nichts. Der Server protokolliert die Eingabe und
// uebernimmt sie, wenn der Container noch keine Nummer hat (bridge.ts, gleiche Normalisierung).
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

/** Wie normalizeRef im Backend: Grossbuchstaben, nur A-Z und 0-9. */
export function normalisiereContainerNr(wert: string | null | undefined): string | null {
  const norm = (wert ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  return norm.length > 0 ? norm : null;
}

type AndererContainer = { id: number; label: string | null; container_no: string | null };

export function ContainerAbgleichFeld({ wert, onWert, soll, andere, onWechseln }: {
  wert: string;
  onWert: (wert: string) => void;
  /** container_no des Containers im Dialog. */
  soll: string | null;
  /** Uebrige Container derselben Bestellung. */
  andere: AndererContainer[];
  onWechseln: (shipmentId: number) => void;
}) {
  const eingabe = normalisiereContainerNr(wert);
  const sollNorm = normalisiereContainerNr(soll);
  const treffer = eingabe === null || eingabe === sollNorm
    ? undefined
    : andere.find((c) => normalisiereContainerNr(c.container_no) === eingabe);
  const trefferName = treffer ? treffer.label ?? `Container #${treffer.id}` : null;

  return (
    <div className="grid gap-1.5 text-sm">
      <label htmlFor="container-abgleich" className="font-medium">Container-Nr. am Container (optional)</label>
      <Input
        id="container-abgleich"
        value={wert}
        onChange={(e) => onWert(e.target.value)}
        placeholder={soll ?? "z. B. TGHU2986487"}
        autoComplete="off"
        spellCheck={false}
        className="font-mono uppercase"
      />
      {eingabe === null ? (
        <p className="text-xs text-ink-2">Nummer am Container ablesen und eintragen — ein Abgleich hilft, Verwechslungen zu vermeiden.</p>
      ) : sollNorm === null && !treffer ? (
        <p className="text-xs text-ink-2">Für diesen Container ist noch keine Nummer hinterlegt. {eingabe} wird mit der Zustellung als Container-Nr. gespeichert.</p>
      ) : eingabe === sollNorm ? (
        <p className="text-xs text-emerald-700 dark:text-emerald-300">Nummer stimmt mit {soll} überein.</p>
      ) : (
        <div role="status" className="grid gap-1.5 rounded border border-amber-300 bg-amber-50 p-2 text-xs text-amber-900 dark:border-amber-700/50 dark:bg-amber-950/20 dark:text-amber-200">
          <span>
            {sollNorm === null ? `Für diesen Container ist noch keine Nummer hinterlegt; ${eingabe} wird nicht übernommen.` : `${eingabe} weicht von ${soll} ab.`}
            {trefferName ? ` Die Nummer gehört zu ${trefferName} dieser Bestellung.` : " Bitte prüfen, ob der richtige Container im Hof steht."}
            {" "}Die Zustellung bleibt möglich.
          </span>
          {treffer ? (
            <Button type="button" size="sm" variant="outline" className="h-7 w-fit text-[11px]" onClick={() => onWechseln(treffer.id)}>
              Zu {trefferName} wechseln
            </Button>
          ) : null}
        </div>
      )}
    </div>
  );
}
